import * as THREE from 'three';
import Fragment from './Fragment';
import grayscaleFragment from '../Shader/grayscale.frag';

export default class ShadowFragment extends Fragment {
  static OPACITY = 1;
  constructor(params) {
    super({
      ...params,
      fragmentShader: grayscaleFragment,
    });
    this.offset = 0;
  }
  randomPosition(position = this.position) {
    super.randomPosition(position);

    // Position
    this.endPosition.z = -this.width - 1;
    this.startPosition = this.endPosition.clone();
    this.position.copy(this.startPosition);
    this.endPosition.multiplyScalar(5);
    const rotate = Math.random();
    this.endRotation = new THREE.Euler(
      0,
      rotate > 0.2 ? (rotate - 0.5) * 10 * Math.PI : 0,
      0,
      'XYZ',
    );
    // this.startPosition.copy(position);
    // this.endPosition.copy(position);
  }
  update(params) {
    this.material.uniforms.opacity.value = 0;

    super.update(params);
  }
  animate(animation) {
    const { transition, rotation, opacity } = animation;
    super.animate({
      transition: Math.max(transition - 1, 0),
      rotation,
      opacity: opacity * ShadowFragment.OPACITY,
    });
  }
}



// WEBPACK FOOTER //
// ./src/scene/Object/ShadowFragment.js